import { DetailedHTMLProps, SelectHTMLAttributes } from 'react';
import * as S from './styles';

interface SelectProps {
  label: string;
  children: DetailedHTMLProps<
    SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  >;
}

export function Select({ label, children }: SelectProps) {
  return (
    <S.Wrapper title={label}>
      <label>{label}</label>
      {children}
    </S.Wrapper>
  );
}
